// Library Import
import { Col, Form, Row } from 'react-bootstrap';
import Proptypes from 'prop-types';

// File Import
import CrossIcon from '~/images/icon/cross-gray.png';
import QuestionMark from '~/images/icon/question_mark.png';

// Components import

export const AddMapSection = ({ handleChange, handleRemoveMapSection, postIndex, mapIndex, item, errors, locationsCsv, disable }) => {
  return (
    <div className='multi-section-wrapper mb-3'>
      {mapIndex > 0 && (
        <div className='remove-item'>
          <img onClick={() => disable === 0 ? {} : handleRemoveMapSection(postIndex, mapIndex)} src={CrossIcon} alt='Cross Icon' />
        </div>
      )}
      <div className='d-flex'>
        <div className='me-auto'>
          <div className='form-label fw-bold mb-3'>
            位置情報<span className='is-required'>*</span>
          </div>
        </div>
        <a href='/storage/mapinfo.pdf' target="_blank">
          <img style={{height: '24px'}} src={QuestionMark} alt="question_mark" />
        </a>
      </div>
      <div className='mb-3'>
        <p className='m-0' style={{fontSize: '14px'}}>以下のいずれかの方法でご登録ください</p>
        <p className='m-0' style={{fontSize: '14px'}}>1　プリセットから登録</p>
        <p className='m-0' style={{fontSize: '14px'}}>2　(プリセット登録がない場合)施設名/住所・プレイスID・場所名称の登録</p>
        <p className='m-0' style={{fontSize: '14px'}}>3　(プレイスIDがない場合)施設名/住所・場所名称・緯度・経度の登録</p>
      </div>
      {/* Preset Name */}
      <Form.Group as={Row} className='mb-3' controlId={'presetName_' + postIndex + '_' + mapIndex}>
        <Form.Label column sm='4' className='text-center'>
          プリセット
        </Form.Label>
        <Col sm='8'>
          <Form.Select
            disabled={disable === 0}
            name='preset_name'
            value={(item?.preset_name || item?.preset_name === '') ? item?.preset_name : 'empty'}
            onChange={(event) => handleChange(event, postIndex, mapIndex)}>
            <option value='empty'>選択してください...</option>
            {locationsCsv?.map((val, idx) => (
              <option key={idx} value={val?.preset_name}>
                {val?.preset_name}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Form.Group>
      {/* Address */}
      <Form.Group as={Row} className='mb-3' controlId={'mapAddress_' + postIndex + '_' + mapIndex}>
        <Col sm='4'>
          <Form.Label className='d-block text-center'>
            施設名/住所
          </Form.Label>
          <span className='text-left' style={{fontSize: '12px'}}>（施設名/住所欄に入力した内容がアプリ画面に反映されます）</span>
        </Col>
        <Col sm='8'>
          <Form.Control
            disabled={disable === 0}
            isInvalid={errors?.address}
            autoComplete='off'
            type='text'
            name='address'
            as='textarea'
            rows={3}
            placeholder='ご記入ください...'
            onChange={(event) => handleChange(event, postIndex, mapIndex)}
            value={item?.address ? item?.address : ''}
          />
          <Form.Control.Feedback type='invalid'>{errors?.address}</Form.Control.Feedback>
        </Col>
      </Form.Group>
      {/* Place ID */}
      <Form.Group as={Row} className='mb-3' controlId={'mapPlaceID_' + postIndex + '_' + mapIndex}>
        <Form.Label column sm='4' className='text-center'>
          プレイスID
        </Form.Label>
        <Col sm='8'>
          <Form.Control
            disabled={disable === 0}
            name='place_id'
            onChange={(event) => handleChange(event, postIndex, mapIndex)}
            type='text'
            placeholder='(例:ChIJy_hZA0GMGGARbA1yKQU8wVA)'
            value={item?.place_id ? item?.place_id : ''}
            isInvalid={errors?.place_id}
          />
          <Form.Control.Feedback type='invalid'>{errors?.place_id}</Form.Control.Feedback>
        </Col>
      </Form.Group>
      {/* Place name */}
      <Form.Group as={Row} className='mb-3' controlId={'mapPlaceName_' + postIndex + '_' + mapIndex}>
        <Col className='text-center' sm='4'>
          <Form.Label className='d-block'>
            場所名称
          </Form.Label>
          <span className='text-nowrap' style={{fontSize: '13px'}}>（Googlemap上の施設名を</span>
          <span className='text-nowrap' style={{fontSize: '13px'}}>ご記載ください)</span>
        </Col>

        <Col sm='8'>
          <Form.Control
            disabled={disable === 0}
            name='place_name'
            onChange={(event) => handleChange(event, postIndex, mapIndex)}
            type='text'
            placeholder='(例:東京しごとセンター)'
            value={item?.place_name ? item?.place_name : ''}
            isInvalid={errors?.place_name}
          />
          <Form.Control.Feedback type='invalid'>{errors?.place_name}</Form.Control.Feedback>
        </Col>
      </Form.Group>
      {/* Latitude */}
      <Form.Group as={Row} className='mb-3' controlId={'mapLatitude_' + postIndex + '_' + mapIndex}>
        <Form.Label column sm='4' className='text-center'>
          緯度
        </Form.Label>
        <Col sm='8'>
          <Form.Control
            disabled={disable === 0}
            name='latitude'
            onChange={(event) => handleChange(event, postIndex, mapIndex)}
            type='text'
            placeholder='(例：35.700324)'
            value={item?.latitude ? item?.latitude : ''}
            isInvalid={errors?.latitude}
          />
          <Form.Control.Feedback type='invalid'>{errors?.latitude}</Form.Control.Feedback>
        </Col>
      </Form.Group>
      {/* Longitude */}
      <Form.Group as={Row} className='mb-3' controlId={'mapLongitude_' + postIndex + '_' + mapIndex}>
        <Form.Label column sm='4' className='text-center'>
          経度
        </Form.Label>
        <Col sm='8'>
          <Form.Control
            disabled={disable === 0}
            name='longitude'
            onChange={(event) => handleChange(event, postIndex, mapIndex)}
            type='text'
            placeholder='(例：139.749796)'
            value={item?.longitude ? item?.longitude : ''}
            isInvalid={errors?.longitude}
          />
          <Form.Control.Feedback type='invalid'>{errors?.longitude}</Form.Control.Feedback>
        </Col>
      </Form.Group>
      {/* Note */}
      <div className='d-flex flex-column'>
        <span className='mb-3' style={{ fontWeight: '100' }}>▼下記URLより、プレイスIDを検索することができます 
        <a href='https://developers.google.com/maps/documentation/places/web-service/place-id?hl=ja'
          target='_blank'>
          https://developers.google.com/maps/documentation/places/web-service/place-id?hl=ja
        </a>
        </span>
        <span className='mb-3' style={{ fontWeight: '100' }}>▼下記URL(Googlemap)より、目的場所を右クリックすることで経度緯度を確認できます<br />
          <a href='https://www.google.co.jp/maps'
            target='_blank'>
            https://www.google.co.jp/maps
          </a>
        </span>

      </div>
    </div>
  );
};

AddMapSection.prototype = {
  handleChange: Proptypes.func,
  handleRemoveMapSection: Proptypes.func,
  postIndex: Proptypes.number,
  mapIndex: Proptypes.number,
  item: Proptypes.object,
  errors: Proptypes.object,
  locationsCsv: Proptypes.array,
  disable: Proptypes.bool,
};
